import { get } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { firebaseConnect, firestoreConnect } from 'react-redux-firebase';
import { Redirect } from 'react-router-dom';
import { compose } from 'redux';
import * as ROUTES from '../../constants/routes';

const ProjectPageLanding = () => {
    return <React.Fragment />
};

const mapStateToProps = (state) => {
    return {
        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        projectCompany: state.firestore.data.ProjectCompany,
    }
}

export default compose(
    connect(mapStateToProps),
    firebaseConnect((props) => {
        let proid = props.project.proid;
        return [
            `ProjectsMeta/${proid}/Notifications`
        ]
    }),
    firestoreConnect((props) => {
        const { project, snagDetail, projectCompany } = props;
        let proid = project.proid;
        let coidOfProid = snagDetail ? snagDetail.coid : "-1";
        let boughtOrderIdOfCoidOfProid = projectCompany ? 'boughtSubscription' in projectCompany ? projectCompany.boughtSubscription.orderId : '-1' : '-1';
        return [
            {
                collection: `Projects/${proid}/Notifications`,
                orderBy: ['timestamp', 'desc'],
                storeAs: "ProjectNotifications",
            },
            {
                collection: "Companies",
                storeAs: "ProjectCompany",
                doc: coidOfProid
            },
            {
                collection: "ProductOrders",
                storeAs: "ProjectProductOrder",
                doc: boughtOrderIdOfCoidOfProid,
            },
        ]
    })
)(ProjectPageLanding);